import { jsx as _jsx } from "react/jsx-runtime";
import { DialogTitleCaption, styled } from '@/core/ui';
import { formatCurrency } from '@/core/localization';
import { getBalanceColor, shouldNotForwardProps } from '@/shared/helpers';
const BalanceValue = ({ value }) => {
    return _jsx(BalanceTypography, { value: value, children: formatCurrency(value) });
};
const BalanceTypography = styled(DialogTitleCaption, shouldNotForwardProps('value'))(({ theme, value }) => ({
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
    color: getBalanceColor(value, theme.palette).main,
}));
export { BalanceValue };
